/**
 * Peruvian sol.
 */
export var PEN = {
  code: 'PEN',
  base: 10,
  exponent: 2
};